import { useState, useEffect } from 'react';
import { m } from 'framer-motion';
// @mui
import { alpha, styled } from '@mui/material/styles';
import { Box, Container, Dialog, DialogContent, DialogContentText, Grid } from '@mui/material';
import { useParams } from 'react-router';
import { CPO_API } from '../config';
// components
import Page from '../components/Page';
import { varFade, MotionViewport } from '../components/animate';
// sections
import { CharityHeader, CharityProfile, CharityContext, CharityDonationBox, CharityProject } from '../sections/charity';
import { CharityAPI } from '../services/charity.services';
import { ProjectAPI } from '../services/projects.services';
import charityParam from '../routes/charity.json';
import Logo from '../components/Logo';

// ----------------------------------------------------------------------
const COLOR_LIGHTBLUE = '#F5FBFF';

const ContentStyle = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(8),
  background: COLOR_LIGHTBLUE,
}));
const HeaderStyle = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  marginTop: theme.spacing(11),
}));
// ----------------------------------------------------------------------

const BASE_URL = CPO_API;

export default function Charity() {
  const [charity, setCharity] = useState(null);
  const { charityName } = useParams();
  const [isLoading, setIsLoading] = useState(true);

  async function getCharityDetails() {
    setIsLoading(true);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const charityId = Object.entries(charityParam).find(([key, val]) => val === charityName);

    const id = (!charityId) ? charityName.replace("CharityId=", "") : charityId[0];
    const response = await fetch(`${BASE_URL}/user/info/charity?_id=${id}`);

    const res = await response.json();
    const data = res.data;

    const { _id, organization } = data;
    const projectres = await ProjectAPI.getProjectsByCharity(organization);
    const projects = projectres.data.records;

    setCharity({
      ...data, projects,
    });
    setIsLoading(false);
  }

  useEffect(() => {
    getCharityDetails();
  }, []);

  return (
    <Page title="CharityPhilippines.org">
      {(charity)
        ?
        <>
          <HeaderStyle>
            <CharityHeader charity={charity} />
          </HeaderStyle>
          <ContentStyle>
            <Container component={MotionViewport}>
              <Grid container spacing={4} mt={3}>
                <Grid item xs={12}>
                  <CharityProfile charity={charity} />
                </Grid>
                <Grid item xs={12} md={7}>
                  <CharityContext charity={charity} />
                </Grid>
                <Grid item xs={12} md={5}>
                  <CharityDonationBox charity={charity} />
                </Grid>
                <Grid item xs={12}>
                  <CharityProject charity={charity} />
                </Grid>
              </Grid>
            </Container>
          </ContentStyle>
        </>
        : <><div>&nbsp;</div></>}
      <Dialog
        PaperProps={{
          sx: {
            width: { md: '20%', xs: '90%' },
            height: 200,
            paddingTop: 5,
            alignItems: 'center',
          },
        }}
        open={isLoading}
        aria-labelledby="responsive-dialog-title"
      >
        <m.div
          initial={{ rotateY: 0 }}
          animate={{ rotateY: 360 }}
          transition={{ duration: 2, ease: 'easeInOut', repeatDelay: 1, repeat: Infinity }}
        >
          <Logo disabledLink sx={{ marginTop: 3, width: 60, height: 25 }} />
        </m.div>

        <Box
          component={m.div}
          animate={{
            scale: [1.2, 1, 1, 1.2, 1.2],
            rotate: [270, 0, 0, 270, 270],
            opacity: [0.25, 1, 1, 1, 0.25],
            borderRadius: ['25%', '25%', '50%', '50%', '25%'],
          }}
          transition={{ ease: 'linear', duration: 3.2, repeat: Infinity }}
          sx={{
            marginTop: 1,
            width: 65,
            height: 65,
            borderRadius: '25%',
            position: 'absolute',
            border: (theme) => `solid 3px ${alpha(theme.palette.primary.dark, 0.24)}`,
          }}
        />

        <DialogContent>
          <DialogContentText
            sx={{
              display: 'flex',
              alignItems: { xs: 'center', md: 'center' },
              marginTop: 4,
            }}
          >
            Loading Charity...
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </Page>
  );
}
